import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminBuildings_idCardExportXlsx = z.any()
export type TagsGetAdminBuildings_idCardExportXlsx = z.infer<typeof tagsGetAdminBuildings_idCardExportXlsx>

export const paramsGetAdminBuildings_idCardExportXlsx = z.object({ "id": z.string().uuid() })
export type ParamsGetAdminBuildings_idCardExportXlsx = z.infer<typeof paramsGetAdminBuildings_idCardExportXlsx>

export const responseGetAdminBuildings_idCardExportXlsx = z.any()
export type ResponseGetAdminBuildings_idCardExportXlsx = z.infer<typeof responseGetAdminBuildings_idCardExportXlsx>

interface IGetAdminBuildings_idCardExportXlsx extends BaseMethodType {
  tags: TagsGetAdminBuildings_idCardExportXlsx,
  params: ParamsGetAdminBuildings_idCardExportXlsx,
  response: ResponseGetAdminBuildings_idCardExportXlsx
}
export const URL = '/admin/buildings/:id/card/export/xlsx'
export const validation = {
  get: {
    tags: tagsGetAdminBuildings_idCardExportXlsx,
    params: paramsGetAdminBuildings_idCardExportXlsx,
    response: responseGetAdminBuildings_idCardExportXlsx
  }
}
export interface AdminBuildings_idCardExportXlsx extends BaseRouteType {
  get: IGetAdminBuildings_idCardExportXlsx
}